module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/sad-0696d5cb58ee1b857c9dbc100e7082f0.svg";